import { z } from "zod";

export const insuranceProviderSchema = z.object({
  id: z.number(),
  providerId: z.number(),
  providerName: z.string(),
  insuranceId: z.number().nullable(),
  insuranceName: z.string().nullable(),
  appointmentTypeId: z.number(),
  appointmentTypeName: z.string(),
  stateId: z.number(),
  stateName: z.string(),
});

const paginationLinksSchema = z.object({
  first: z.string().nullable(),
  last: z.string().nullable(),
  prev: z.string().nullable(),
  next: z.string().nullable(),
});

const paginationMetaSchema = z.object({
  current_page: z.number(),
  from: z.number().nullable(),
  last_page: z.number(),
  path: z.string(),
  per_page: z.number(),
  to: z.number().nullable(),
  total: z.number(),
});

export const insuranceProvidersResponseSchema = z.object({
  data: z.array(insuranceProviderSchema),
  links: paginationLinksSchema,
  meta: paginationMetaSchema,
});

export const importInsuranceProvidersResponseSchema = z.object({
  data: z.object({
    imported: z.number(),
    skipped: z.number(),
    duplicates: z.number(),
  }),
});
